import { axios, handleError } from '../axios';

export const adminLogout = () => {
  return new Promise((resolve) => {
    axios
      .post('admin/account/logout')
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
